<template>
  <div
    class="header-box"
    :class="[
      `theme-${navTheme}`,
      { top500: navFixed || scrollTop > 100 },
      { wait: isWait }
    ]"
  >
    <div class="left">
      <div class="logo">
        <img
          src="@/assets/img/logo/logo.png"
          alt="赛博威"
          v-show="navFixed || scrollTop > 100 || navTheme === 'black'"
          @click="toPage('home')"
        />
        <img
          src="@/assets/img/logo/logo-w.png"
          alt="赛博威"
          v-show="!navFixed && scrollTop < 100 && navTheme === 'white'"
          @click="toPage('home')"
        />
      </div>
      <div :class="{ selected: selected === 'home' }" @click="toPage('home')">
        <span>首页</span>
        <span class="line"></span>
      </div>
      <div :class="{ selected: selected === 'products' }">
        <span>产品服务</span>
        <span class="line"></span>
        <div
          class="hover-box product"
          :class="{ top500: navFixed || scrollTop > 100 }"
        >
          <div class="blank"></div>
          <div class="backdrop-filter">
            <div class="lists">
              <div class="list">
                <div class="right-text">
                  <div class="right-text-item">
                    <div @click="toPage('/products/cyber-insight')">
                      <img
                        v-lazy="require('@/assets/img/header/item-14.png')"
                        alt="数智化专业咨询伙伴"
                      />
                      <span>数智化专业咨询伙伴</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="line"></div>
              <div class="list">
                <div class="right-text">
                  <div class="right-text-title">Application</div>
                  <div class="right-text-item">
                    <div @click="toPage('/products/cyber-tpm')">
                      <img
                        v-lazy="require('@/assets/img/header/item-1.png')"
                        alt="高阶数智化营销费用管理（Cyber TPM）"
                      />
                      <span>高阶数智化营销费用管理（Cyber TPM）</span>
                    </div>
                  </div>
                  <div class="right-text-item">
                    <div @click="toPage('/products/tpm+')">
                      <img
                        v-lazy="require('@/assets/img/header/item-2.png')"
                        alt="营销费用管理 Plus（TPM +）"
                      />
                      <span>营销费用管理 Plus（TPM +）</span>
                    </div>
                  </div>
                  <div class="right-text-item">
                    <div @click="toPage('/products/b2b')">
                      <img
                        v-lazy="require('@/assets/img/header/item-5.png')"
                        alt="智能订货协同平台（B2B）"
                      />
                      <span>智能订货协同平台（B2B）</span>
                    </div>
                  </div>
                  <div class="right-text-item">
                    <div @click="toPage('/products/sfa')">
                      <img
                        v-lazy="require('@/assets/img/header/item-3.png')"
                        alt="销售能力自动化（SFA）"
                      />
                      <span>销售能力自动化（SFA)</span>
                    </div>
                  </div>
                  <div class="right-text-title mt-20">Analytics</div>
                  <div class="right-text-item">
                    <div @click="toPage('/products/mdm')">
                      <img
                        v-lazy="require('@/assets/img/header/item-9.png')"
                        alt="主数据管理（MDM）"
                      />
                      <span>主数据管理（MDM）</span>
                    </div>
                  </div>
                  <div class="right-text-item" @click="toPage('/products/bi')">
                    <div>
                      <img
                        v-lazy="require('@/assets/img/header/item-8.png')"
                        alt="全域商业洞察（BI）"
                      />
                      <span>全域商业洞察（BI）</span>
                    </div>
                  </div>
                  <div class="right-text-item">
                    <div @click="toPage('/products/npi')">
                      <img
                        v-lazy="require('@/assets/img/header/item-6.png')"
                        alt="产品创新协同平台"
                      />
                      <span>产品创新协同平台</span>
                    </div>
                  </div>
                  <div class="right-text-item">
                    <div @click="toPage('/products/SaaS')">
                      <img
                        v-lazy="require('@/assets/img/header/item-19.png')"
                        alt="产品创新平台（SaaS版）"
                      />
                      <span>产品创新平台（SaaS版）</span>
                    </div>
                  </div>
                  <div class="right-text-item">
                    <div @click="toPage('/products/coi')">
                      <img
                        v-lazy="require('@/assets/img/header/item-7.png')"
                        alt="消费者意见洞察"
                      />
                      <span>消费者意见洞察</span>
                    </div>
                  </div>
                  <div class="right-text-title mt-20">AI</div>
                  <div class="right-text-item">
                    <div @click="toPage('/ai-scene')">
                      <img
                        v-lazy="require('@/assets/img/header/item-16.png')"
                        alt="快消零售行业AI应用场景"
                      />
                      <span>快消零售行业AI应用场景</span>
                    </div>
                  </div>
                  <div class="right-text-item">
                    <div @click="toPage('/products/AI')">
                      <img
                        v-lazy="require('@/assets/img/header/item-15.png')"
                        alt="CYBER  AI  X  Dify"
                      />
                      <span>CYBER AI X Dify</span>
                    </div>
                  </div>
                  <!-- <div class="right-text-item">
                    <div @click="toPage('/products/AI#two')">
                      <img
                        v-lazy="require('@/assets/img/header/item-17.png')"
                        alt="大消费行业营销链路智能应用"
                      />
                      <span>大消费行业营销链路智能应用</span>
                    </div>
                  </div>
                  <div class="right-text-item">
                    <div @click="toPage('/products/AI#three')">
                      <img
                        v-lazy="require('@/assets/img/header/item-16.png')"
                        alt="AI智能助手集成"
                      />
                      <span>AI智能助手集成</span>
                    </div>
                  </div> -->
                  <div class="right-text-item">
                    <div @click="toPage('/products/AI_box')">
                      <img
                        v-lazy="require('@/assets/img/header/item-18.png')"
                        alt="CYBER AI Agent BOX"
                      />
                      <span>CYBER AI Agent BOX</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="line"></div>
              <div class="list">
                <div class="right-text">
                  <div class="right-text-item">
                    <div @click="toPage('/products/som')">
                      <img
                        v-lazy="require('@/assets/img/header/item-15.png')"
                        alt="系统运维"
                      />
                      <span>系统运维</span>
                    </div>
                  </div>
                  <div class="right-text-item">
                    <div @click="toPage('/products/ai-ops')">
                      <img
                        v-lazy="require('@/assets/img/header/item-13.png')"
                        alt="AI运维数字员工"
                      />
                      <span>AI运维数字员工</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="line"></div>
              <div class="list">
                <div class="left">
                  <span class="text">
                    地产石化
                    <span class="img">
                      <img
                        v-lazy="
                          require('@/assets/img/industrySolutions/next-b.png')
                        "
                        alt="地产石化"
                      />
                    </span>
                  </span>
                </div>
                <div class="right-text">
                  <div class="right-text-item">
                    <div @click="toPage('/products/ic')">
                      <img
                        v-lazy="require('@/assets/img/header/item-10.png')"
                        alt="智慧物业管理"
                      />
                      <span>智慧物业管理</span>
                    </div>
                  </div>
                  <div class="right-text-item">
                    <div @click="toPage('/products/sp')">
                      <img
                        v-lazy="require('@/assets/img/header/item-12.png')"
                        alt="智慧石化"
                      />
                      <span>智慧石化</span>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div :class="{ selected: $route.fullPath === '/ai-scene' }" @click="toPage('ai-scene')">
        <span>AI 应用场景</span>
        <span class="line"></span>
      </div>
      <div
        :class="{ selected: selected === 'scheme' }"
        @click="toPage('scheme')"
      >
        <span>行业解决方案</span>
        <span class="line"></span>
      </div>
      <div :class="{ selected: selected === 'goIn' }">
        <span>走进Cyberway</span>
        <span class="line"></span>
        <div
          class="hover-box go-in"
          :class="{ top500: navFixed || scrollTop > 100 }"
        >
          <div class="blank"></div>
          <div class="backdrop-filter">
            <div class="lists">
              <div class="list" @click="toPage('/goin/about')">
                <span class="text">
                  关于赛博威
                  <span class="img">
                    <img
                      v-lazy="
                        require('@/assets/img/industrySolutions/next-b.png')
                      "
                      alt="关于赛博威"
                    />
                  </span>
                </span>
              </div>
              <div class="list" @click="toPage('/goin/news')">
                <span class="text">
                  品牌资讯
                  <span class="img">
                    <img
                      v-lazy="
                        require('@/assets/img/industrySolutions/next-b.png')
                      "
                      alt="品牌资讯"
                    />
                  </span>
                </span>
              </div>
              <div class="list" @click="toPage('/goin/join-us')">
                <span class="text">
                  加入我们
                  <span class="img">
                    <img
                      v-lazy="
                        require('@/assets/img/industrySolutions/next-b.png')
                      "
                      alt="加入我们"
                    />
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="versions">
        <span>简体中文<i class="arrow"></i></span>
        <span class="line"></span>
        <div
          class="hover-box versions"
          :class="{ top500: navFixed || scrollTop > 100 }"
        >
          <div class="blank"></div>
          <div class="backdrop-filter">
            <div class="lists">
              <div
                class="list list-active"
                @click="openLink('https://www.cyberway.com.cn')"
              >
                <span class="text">
                  简体中文
                  <span class="img">
                    <img
                      v-lazy="require('@/assets/img/home/gou.png')"
                      alt="Cyberway"
                    />
                  </span>
                </span>
              </div>
              <div
                class="list"
                @click="openLink('https://www.cyberwayinc.com')"
              >
                <span class="text">
                  English
                  <span class="img none">
                    <img
                      v-lazy="require('@/assets/img/home/gou.png')"
                      alt="SFA"
                    />
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tel">
        <span class="circle">
          <img v-lazy="require('@/assets/img/top-tel.png')" alt="tel" />
        </span>
        <span>400-168-0262</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "newHeader",
  computed: {
    ...mapGetters(["navTheme", "navFixed"])
  },
  data() {
    return {
      scrollTop: 0,
      selected: "home",
      isWait: true // 顶部等待三秒再出现
    };
  },
  watch: {
    $route(to, from) {
      // navThemeCustom 设置时在组件内部处理
      if (!(to.meta && to.meta.navThemeCustom)) {
        this.$store.dispatch(
          "setNavTheme",
          (to.meta && to.meta.navTheme) || "white"
        );
      }

      // 顶部栏是否固定 - 默认不固定
      console.log("navFixed", to.meta && to.meta.navFixed);
      this.$store.dispatch(
        "setNavFixed",
        (to.meta && to.meta.navFixed) || false
      );

      this.init();
    }
  },
  methods: {
    init() {
      const { pathname } = location;
      console.log("path", location);
      if (pathname.includes("home")) {
        this.selected = "home";
      } else if (pathname.includes("products")) {
        this.selected = "products";
      }else if(pathname.includes("ai-scene")){
        this.selected = "ai-scene";
      }else if (pathname.includes("capabilities")) {
        this.selected = "capabilities";
      } else if (pathname.includes("solutions")) {
        this.selected = "scheme";
      } else if (pathname.includes("goin")) {
        this.selected = "goIn";
      }
    },
    doScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log(scrollTop)
      this.scrollTop = scrollTop;
    },
    toPage(value, index) {
      this.selected = value;
      switch (value) {
        case "home":
          this.$router.push("/");
          break;
        case "scheme":
          this.$router.push("/solutions");
          break;
        case "capabilities":
          this.$router.push("/capabilities");
          break;
        case "ai-scene":
          this.$router.push("/ai-scene");
          break;
        default:
          console.log("default", value);
          this.$router.push(value);
          break;
      }
      if (index) {
        this.$emit("goAnchor", index);
      }
      // 将 class 为 hover-box 的元素 hover
      const hoverBox = document.getElementsByClassName("hover-box");
      for (let i = 0; i < hoverBox.length; i++) {
        hoverBox[i].style.display = "none";
      }
      const timer = setTimeout(() => {
        clearTimeout(timer);
        // 移除 style
        for (let i = 0; i < hoverBox.length; i++) {
          hoverBox[i].removeAttribute("style");
        }
      }, 16);
    },
    jumpTo(url) {
      window.open(url);
    },
    openLink(url) {
      window.location.href = url;
    }
  },
  created() {
    window.addEventListener("scroll", this.doScroll);

    const timer = setTimeout(() => {
      this.isWait = false;
      clearTimeout(timer);
    }, 3000);
  },
  mounted() {
    this.init();
    console.log(this.navTheme);
  }
};
</script>

<style lang="scss" scoped>
.header-box {
  height: 110px;
  width: 105%;
  position: fixed;
  z-index:1000;
  padding: 58px 165px 45px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &.top500 {
    color: #383d44 !important;
    background-color: #fff;
    animation: fade-in 0.6s ease;
  }

  &.theme-white {
    color: #ffffff;
  }

  &.theme-black {
    color: #383d44;
  }

  .left {
    display: flex;
    align-items: center;

    > div {
      margin-right: 81px;
      font-size: 17px;
      font-family: "MiSans-Normal-";
      line-height: 52px;
      cursor: pointer;
      position: relative;

      &:hover {
        position: relative;
        > span {
          font-family: "MiSans-Bold-";
          color: #1d56de;
        }
        .line {
          position: absolute;
          height: 2px;
          width: 79px;
          background-color: #005fe6;
          bottom: 0px;
          left: 50%;
          transform: translateX(-50%);
        }
        .hover-box {
          display: block;
          animation: fade-in 0.2s;
        }
      }

      .hover-box {
        top: 52px;
        left: 50%;
        transform: translateX(-50%);
        width: 204px;
        position: absolute;
        display: none;
        cursor: default;

        &.top500 {
          .backdrop-filter {
            backdrop-filter: blur(2px);
          }
          .lists {
            opacity: 0.9;
          }
        }

        &.product {
          width: 800px;
          left: -50px;
          transform: none;

          .backdrop-filter {
            border-radius: 22px;
            overflow: hidden;
            box-shadow: 0px 2px 10px 1px rgba(0, 0, 0, 0.15);
          }

          .lists {
            padding: 0 0 30px 0;

            .line {
              width: 1018px;
              height: 1px;
              opacity: 1;
              background-color: #c1c1c1;
              position: relative;
            }

            .list {
              font-size: 19px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              height: auto;
              padding: 14px 52px 10px;

              .left {
                width: 388px;
                height: 40px;
                line-height: 40px;
                flex-grow: 0;
                flex-shrink: 0;

                .text {
                  padding-left: 50px;
                  margin-left: 0;
                  margin-top: -5px;
                  font-family: "MiSans-Semibold-";
                  line-height: 28px;
                }
              }

              .right-text {
                flex-grow: 1;
                display: flex;
                flex-wrap: wrap;
                .right-text-title {
                  width: 100%;
                  font-size: 20px;
                  font-family: "MiSans-Demibold-";
                  line-height: 28px;
                  color: #00094c;
                  margin-bottom: 16px;
                }
                .mt-20 {
                  margin-top: 25px;
                }
                .right-text-item {
                  width: 50%;
                  line-height: 40px;
                  height: 40px;
                  font-size: 17px;
                  // font-family: "MiSans-Normal-";
                  font-family: "MiSans-Demibold-";
                  line-height: 28px;
                  color: #686868;
                  display: flex;
                  align-items: center;
                  cursor: default;
                  > div {
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    height: 20px;
                    line-height: 20px;

                    span {
                      height: 20px;
                      line-height: 20px;
                    }

                    &:hover {
                      font-family: "MiSans-Demibold-";
                      //font-family: "MiSans-Normal-";
                      color: #1d56de;
                    }
                  }

                  .disabled {
                    cursor: not-allowed;
                    color: #c1c1c1;
                    &:hover {
                      color: #c1c1c1;
                      font-family: "MiSans-Normal-";
                    }
                  }

                  img {
                    width: 16px;
                    height: 17px;
                    margin-right: 8px;
                  }
                }

                .w-large {
                  width: 66.66%;
                }
              }
            }

            .list-large {
              height: 74px;
            }
          }
        }
        &.go-in {
          .backdrop-filter {
            border-radius: 22px;
            overflow: hidden;
            box-shadow: 0px 2px 10px 1px rgba(0, 0, 0, 0.15);
          }

          .lists {
            .text {
              cursor: pointer;
            }
          }
        }
        .blank {
          height: 22px;
          width: 100%;
        }
        .lists {
          padding: 8px 0;
          background-color: #fff;
          border-radius: 7px;
        }
        .list {
          display: flex;
          height: 47px;
          align-items: center;
          font-size: 17px;
          justify-content: center;

          &:hover {
            background: linear-gradient(
              to right,
              #f0f3ffff,
              #f0f3fff5,
              #f2f4ffd9,
              #f5f7ffab,
              #f8faff6b,
              #fdfdff1a,
              #ffffff00
            );
            .text {
              font-family: "MiSans-Demibold-";
              color: #1d56de;
            }
            .img {
              visibility: visible;
            }
          }

          .text {
            font-family: "MiSans-Regular-";
            color: #000;
            position: relative;
          }

          .img {
            visibility: hidden;
            position: absolute;
            right: -40px;
            top: 50%;
            transform: translateY(-56%);
          }
          img {
            width: 9px;
            height: 15px;
          }
        }
      }
      &.selected {
        font-family: "MiSans-Bold-";
        color: #1d56de;
        position: relative;

        .line {
          position: absolute;
          height: 2px;
          width: 79px;
          background-color: #005fe6;
          bottom: 0px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }

    .logo {
      img {
        width: 153px;
        height: 50px;
      }
    }
  }
  .right {
    display: flex;
    align-items: center;
    > div {
      font-size: 17px;
      font-family: "MiSans-Normal-";
      line-height: 52px;
      cursor: pointer;
      position: relative;

      &:hover {
        position: relative;
        > span {
          //font-family: "MiSans-Normal-";
          color: #1d56de;
        }
        .line {
          position: absolute;
          height: 2px;
          width: 100px;
          background-color: #005fe6;
          bottom: 0px;
          left: 65%;
          transform: translateX(-50%);
        }
        .hover-box {
          display: block;
          animation: fade-in 0.2s;
        }
      }

      .hover-box {
        top: 52px;
        left: 75%;
        transform: translateX(-50%);
        //width: 204px;
        width: 130px;
        position: absolute;
        display: none;
        cursor: default;

        &.top500 {
          .backdrop-filter {
            backdrop-filter: blur(2px);
          }
          .lists {
            opacity: 0.9;
          }
        }

        &.go-in {
          .backdrop-filter {
            //width: 130px;
            border-radius: 7px;
            overflow: hidden;
            box-shadow: 0px 2px 10px 1px rgba(0, 0, 0, 0.15);
          }

          .lists {
            .text {
              cursor: pointer;
            }
          }
        }
        .blank {
          height: 22px;
          width: 100%;
        }
        .lists {
          padding: 8px 0;
          background-color: #fff;
          border-radius: 7px;
        }
        .list {
          display: flex;
          height: 35px;
          padding-left: 17px;
          align-items: center;
          font-size: 17px;
          //justify-content: center;

          &:hover {
            background: linear-gradient(
              to right,
              #f0f3ffff,
              #f0f3fff5,
              #f2f4ffd9,
              #f5f7ffab,
              #f8faff6b,
              #fdfdff1a,
              #ffffff00
            );
            .text {
              //font-family: "MiSans-Demibold-";
              color: #1d56de;
            }
            .img {
              visibility: visible;
            }
          }

          .text {
            font-family: "MiSans-Regular-";
            color: #000;
            position: relative;
          }

          .img {
            visibility: hidden;
            position: absolute;
            right: -30px;
            top: 50%;
            transform: translateY(-56%);
          }
          img {
            width: 15px;
            height: 14px;
          }
        }
        .list-active {
          background: linear-gradient(
            to right,
            #f0f3ffff,
            #f0f3fff5,
            #f2f4ffd9,
            #f5f7ffab,
            #f8faff6b,
            #fdfdff1a,
            #ffffff00
          );
          .text {
            //font-family: "MiSans-Demibold-";
            color: #1d56de;
          }
          .img {
            visibility: visible;
          }
        }
      }
      &.selected {
        font-family: "MiSans-Normal-";
        color: #1d56de;
        position: relative;

        .line {
          position: absolute;
          height: 2px;
          width: 79px;
          background-color: #005fe6;
          bottom: 0px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
    .versions {
      margin-right: 55px;
      position: relative;
      // .arrow {
      //   position: absolute;
      //   right: -22px;
      //   top: 20px;
      //   display: inline-block;
      //   content: "";
      //   width: 15px;
      //   height:15px;
      //   background:url('../assets/img/home/arrow1.png') no-repeat;
      //   background-size: 100% 100%;
      // }
      // &:hover{
      //   .arrow {
      //   width: 15px;
      //   height:15px;
      //   background:url('../assets/img/home/arrow2.png') no-repeat;
      //   background-size: 100% 100%;
      // }
      // }
    }
    .tel {
      font-size: 28px;
      font-family: "MiSans-Demibold-";
      color: #1d56de;
      display: flex;
      align-items: center;
      .circle {
        width: 31px;
        height: 31px;
        border-radius: 50%;
        margin-right: 14px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}

.wait {
  animation: wait-in 3s ease;
}

/* 定义动画 */
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes wait-in {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.none {
  display: none !important;
}
.header-box.theme-white .arrow {
  position: absolute;
  right: -22px;
  top: 20px;
  display: inline-block;
  content: "";
  width: 15px;
  height: 15px;
  background: url("../assets/img/home/arrow1.png") no-repeat !important;
  background-size: 100% 100% !important;
}
.header-box.theme-white:hover .arrow {
  width: 15px;
  height: 15px;
  background: url("../assets/img/home/arrow2.png") no-repeat !important;
  background-size: 100% 100% !important;
}
.header-box.theme-black .arrow {
  position: absolute;
  right: -22px;
  top: 20px;
  display: inline-block;
  content: "";
  width: 15px;
  height: 15px;
  background: url("../assets/img/home/arrow3.png") no-repeat !important;
  background-size: 100% 100% !important;
}
.header-box.theme-black:hover .arrow {
  width: 15px;
  height: 15px;
  background: url("../assets/img/home/arrow2.png") no-repeat !important;
  background-size: 100% 100% !important;
}
.header-box.top500 .arrow {
  position: absolute;
  right: -22px;
  top: 20px;
  display: inline-block;
  content: "";
  width: 15px;
  height: 15px;
  background: url("../assets/img/home/arrow3.png") no-repeat !important;
  background-size: 100% 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/NewHeader.vue